var viewer = require("pdfjs-dist/web/pdf_viewer");

class PDFFindController extends viewer.PDFFindController {
  /**
   * Custom implementation of phrase matching for searching in the PDF.
   * This implementation avoids the issue of either missing spaces or too
   * many spaces between words in a phrase when in a PDF - for example,
   * if a phrase wraps over a line in the PDF, often there is no space
   * between the last word in the first line and the first word in the
   * second line, so a phrase search would not find the line correctly.
   * There also exists a situation where the PDF inserts multiple spaces
   * between words to display a line with larger word spacing.
   *
   * To solve these issues, we extract the first word from the query
   * and mark all indices that the query word appears. We then collapse
   * the query, removing all spaces, and collapse the PDF's page content.
   * Doing this, we can see if the rest of the query exists in the PDF
   * without caring about spaces.
   */
  _calculatePhraseMatch(query, pageIndex, pageContent, entireWord) {
    const matches = [];

    // split query into individual words
    const queryArray = query.match(/\S+/g);
    // collapse the query, remove all whitespace
    const collapsedQuery = query.replace(/\s+/g, "");

    let startIndex = 0;
    let potentialStartIndices = [];
    let index;
    // get ALL indices of the first query word
    // these are all potential phrase matches
    while ((index = pageContent.indexOf(queryArray[0], startIndex)) > -1) {
      potentialStartIndices.push(index);
      startIndex = index + queryArray[0].length;
    }

    // for each potential phrase match starting point, we
    // need to see if the whole phrase is present here
    potentialStartIndices.forEach((idx) => {
      // we only care about what comes after this index
      let searchContent = pageContent.substring(idx);
      // collapse the rest of this page's content to avoid space issues
      let collapsedContent = searchContent.replace(/\s+/g, "");
      // we only want to match up to the length of the query - if the
      // full query exists LATER in the page content we will duplicate
      // matches
      collapsedContent = collapsedContent.substring(0, collapsedQuery.length);
      // if the collapsed page content contains the entire collapsed query,
      // this is a match
      if (collapsedContent.includes(collapsedQuery)) {
        matches.push(idx);
      }
    });

    this._pageMatches[pageIndex] = matches;
  }
}

export { PDFFindController };
